import { StyleSheet } from 'react-native';
import theme from '@/constants/colors';
import { Typography } from '@/constants/typography';

const styles = StyleSheet.create({
  container: {
    flexGrow: 1,
    backgroundColor: theme.backgroundPrimary,
    paddingHorizontal: 24,
    paddingBottom: 40,
  },
  bigHeader: {
    paddingTop: 24,
    paddingBottom: 12,
  },
  hugeTitle: {
    ...Typography.h1(theme.accentPrimary),
    fontSize: 36,
    lineHeight: 44,
    marginBottom: 10,
  },
  bigSubtitle: {
    ...Typography.h2(theme.textMuted),
  },
  statsGridTop: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    gap: 6,
    justifyContent: 'space-between',
    marginTop: 8,
  },
  statCard: {
    width: '32%',
    backgroundColor: theme.backgroundPrimary,
    borderRadius: 12,
    padding: 14,
    marginBottom: 12,
    borderWidth: 1,
    borderColor: theme.borderSubtle,
  },
  statLabel: {
    ...Typography.caption(theme.textMuted),
    marginBottom: 6,
  },
  statValue: {
    ...Typography.h3(theme.accentPrimary),
  },
  bottomSheet: {
    position: 'absolute',
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'transparent',
  },
  bottomContent: {
    backgroundColor: theme.backgroundSecondary,
    borderTopLeftRadius: 20,
    borderTopRightRadius: 20,
    padding: 20,
    paddingBottom: 80,
  },
  bottomTitle: {
    ...Typography.h1(theme.accentPrimary),
    fontSize: 28,
    marginBottom: 8,
  },
  bottomSubtitle: {
    ...Typography.body(theme.textMuted),
    marginBottom: 20,
  },
  starRow: {
    flexDirection: 'row',
    justifyContent: 'center',
    gap: 6,
  },
  starButton: {
    width: 56,
    height: 56,
    borderRadius: 28,
    justifyContent: 'center',
    alignItems: 'center',
  },
  star: {
    fontSize: 42,
    color: theme.backgroundSecondaryVarient,
  },
  starFilled: {
    color: theme.accentPrimary,
    textShadowColor: 'rgba(255, 254, 119, 0.3)',
    textShadowRadius: 12,
  },
  ratingLabelContainer: {
    marginTop: 12,
    alignItems: 'center',
  },
  ratingLabel: {
    ...Typography.h2(theme.accentPrimary),
    fontSize: 20,
  },
});

export default styles;